import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["indicator"]

  markAsRead() {
    // 自身のリストアイテムにある未読インジケーター（黄色い線）を即座に隠す
    this.indicatorTargets.forEach(el => el.classList.add("hidden"))

    // 画面内にあるすべてのグローバル通知バッジ（サイドバー、ダッシュボード等）の件数を1減らす（または隠す）
    document.querySelectorAll('[data-controller="admin--notification-badge"]').forEach(el => {
      const badgeText = el.querySelector('[data-admin--notification-badge-target="text"]')
      if (badgeText) {
        let countText = badgeText.textContent.replace(/[^0-9]/g, '')
        let count = parseInt(countText) || 0

        if (count > 0) {
          count -= 1
          if (count === 0) {
            badgeText.classList.add("hidden")
            badgeText.textContent = ""

            const badgeIcon = el.querySelector('[data-admin--notification-badge-target="badge"]')
            if (badgeIcon) badgeIcon.classList.add("hidden")
          } else {
            // "件" がついていれば戻す、数値だけなら数値をそのまま入れる
            badgeText.textContent = badgeText.textContent.includes("件") ? `${count}件` : count
          }
        }
      }
    })
  }
}
